<template>
  <div></div>
</template>

<script>
export default {
  name: "RedirectPage",
  beforeMount() {
    const url = localStorage.getItem('nishika_redirect')
    localStorage.removeItem('nishika_redirect')
    if (url) {
      window.location.href = url
    } else {
      window.location.href = `${process.env.VUE_APP_NISHIKA_PROFILE_URL}/dashboard`
    }
  }
}
</script>

<style scoped>

</style>